import * as PropTypes from 'prop-types';

import {
  WORKFLOW_TEMPLATE_VERSION_SUMMARY_SHAPE,
  WorkflowTemplateVersionSummary,
} from 'workflows/WorkflowConstants';

export interface WorkflowTemplateSelectionTableRow {
  isSelected: boolean;
  workflowTemplateId: string;
  workflowTemplateName: string;
  selectedVersionId: string | null;
  templateVersions: Array<WorkflowTemplateVersionSummary>;
}

export const WORKFLOW_TEMPLATE_SELECTION_TABLE_ROW_SHAPE = PropTypes.shape({
  isSelected: PropTypes.bool.isRequired,
  workflowTemplateId: PropTypes.string.isRequired,
  workflowTemplateName: PropTypes.string.isRequired,
  selectedVersionId: PropTypes.string,
  templateVersions: PropTypes.arrayOf(WORKFLOW_TEMPLATE_VERSION_SUMMARY_SHAPE).isRequired,
});

export interface CreateWorkflowState {
  isLoading: boolean;
  isInputValid?: boolean;
  // If isLoading is false, tableRows will always exist.
  tableRows: Array<WorkflowTemplateSelectionTableRow> | null;
  // The resolved selected version, or null if there is no selection.
  selectedWorkflowTemplateVersionId: string | null;
  rootFolderId: string | null;
  name?: string;
}
